/**
 * One tick of the direct-to-blob-storage upload. Emitted repeatedly while bytes
 * travel, and one last time with `isCompleted: true` once the storage service
 * acknowledges the write.
 */
export class PurchaseFileUploadProgressModel {
  uploadProgressPercentage: number;
  isCompleted: boolean;

  constructor(data: { uploadProgressPercentage: number; isCompleted: boolean }) {
    this.uploadProgressPercentage = data.uploadProgressPercentage;
    this.isCompleted = data.isCompleted;
  }
}
